var __rspack_ns_object = JSON.parse('{"Copied":"تم النسخ","Failed to copy":"فشل النسخ"}')